export const WAREHOUSE_NAMES = {
  LIT: "LIT",
  LOGENT: "LOGENT",
  VIRTUAL: "VIRTUAL",
} as const;
